<template>
	<Card style="height: 600px; overflow-y: auto; overflow-x: hidden">
		<div class="yl-flex flex_between">
			<Form :label-width="80">
				<FormItem label="时间">
					<RadioGroup v-model="timePeriod" @on-change="changeDate">
						<Radio label="0" border><span>不限</span></Radio>
						<Radio label="1" border><span>今日</span></Radio>
						<Radio label="2" border><span>昨天</span></Radio>
						<Radio label="3" border><span>本周</span></Radio>
						<Radio label="4" border><span>上周</span></Radio>
						<Radio label="5" border><span>本月</span></Radio>
						<Radio label="6" border><span>上月</span></Radio>
						<Radio label="7" border><span>自定义</span></Radio>
						<DatePicker v-if="timePeriod == '7' " :value="timePeriodDate" @on-change="changeTimePeriod"
							type="daterange" placeholder="选择日期" style="width: 200px"></DatePicker>
					</RadioGroup>
				</FormItem>
				<FormItem label="条件">
					<el-select v-model="operationUser" style="width: 100px;margin-left: 10px;width: 150px;"
						:reserve-keyword="true" filterable multiple placeholder="请选择运营">
						<el-option v-for="item in operationList" :value="item.uid" :label="item.username"
							:key="item.uid">
							{{ item.username}}
						</el-option>
					</el-select>
					<el-Input placeholder="计划id" v-model="searchAdid"
						style="width: 100px;margin-left: 10px;width: 150px;"></el-Input>
					<el-Button type="primary" @click="mySearch" style="margin-left: 10px;">搜索</el-Button>
					<el-Button @click="initSearch" style="margin-left: 10px;">重置</el-Button>
				</FormItem>
			</Form>
		</div>
		<div style="width: 100% ;margin-top: 20px;">
			<Table :columns="defaultColumns" :data="datas" ref="table" @on-sort-change="handleSortChange">
				<template slot-scope="{ row,index }" slot="adid">
					<span style="color:#63B3E6;cursor: pointer;"
						@click.stop="adidDataClick(row.promotionid)">{{row.promotionid}}</span>
				</template>
				<template slot-scope="{ row,index }" slot="remark">
					<div v-for="(item,index) in row.alarm_msg"
						:class="{'one': item.name == 'one','twoplus':item.name == 'twoplus','threeplus':item.name == 'threeplus','cost':item.name == 'cost'}">
						<span>{{item.msg}}</span>
					</div>
				</template>
			</Table>
		</div>
		<div>
			<Page show-total :total="count" show-sizer :page-size="pageSize" :page-size-opts="pageSizeOpts"
				:current="page" @on-change="changePage" @on-page-size-change="changeSize" size="small" show-elevator />
		</div>
		<Modal v-model="adidDataModal" width="1200" title="">
			<adidData :adid="adid" :timePeriod="timePeriod" :timePeriodDate="timePeriodDate" :city="city" :src="src"
				:account="account" :operationUser="operationUser"></adidData>
		</Modal>
		<Modal v-model="clientListModal" width="1200" title="">
			<clientList :cityList="cityList" :cidTypeList="cidTypeList" :srcList="srcList" :accountList="accountList"
				:operationList="operationList" :account="account" :operationUser="operationUser"></clientList>
		</Modal>
		<!--Card>
			<clientList :adid="adid" :timePeriod="timePeriod" :timePeriodDate="timePeriodDate" :city="city" :src="src"
				:account="account" :operationUser="operationUser"></clientList>
		</Card-->
	</Card>
</template>
<script>
	import {
		mapGetters
	} from "vuex";
	import {
		getAdvCity,
	} from "../../api/runSet";
	import {
		getDefaultCityDemandList,
		saveSingleDefaultDemand,
		getCidTypeList,
		saveAllDemand,
		getAdidDataList,
		getAllAccountList,
		getAllOperationList,
		getToutiaoSrc
	} from "../../api/advManage.js";
	import adidData from "./components/adidData.vue"
	import clientList from "./components/clientList.vue"
	import cityData from "../../assets/citydata";

	export default {
		name: "toutiao_adv_data",
		components: {
			adidData,
			clientList
		},

		data() {
			return {
				datas: [],
				timePeriod: '1',
				timePeriodDate: [],
				page: 1,
				pageSize: 20,
				editStatus: 0,
				pageSizeOpts: [20, 50, 100, 500],
				count: 0,
				city: '',
				src: '',
				advCity: '',
				cid_type: '',
				cityList: [],
				cidTypeList: [],
				srcList: [],
				accountList: [],
				operationList: [],
				operationUser: [],
				account: [],
				adidDataModal: false,
				clientListModal: false,
				adid: '',
				zero_convert: 1,
				searchAdid: '',
				sort: { // 排序参数  
					field: '', // 排序的字段  
					order: '' // 排序的顺序（'ascending' 或 'descending'）  
				},
				defaultColumns: [{
						"title": "计划id",
						"slot": "adid",
						"align": 'center',
					},
					{
						"title": "账户名称",
						"key": "account_name",
						"align": 'center',
					},
					{
						"title": "运营",
						"key": "username",
						"align": 'center',
					},
					{
						"title": "计划名称",
						"key": "cdp_promotion_name",
						"align": 'center',

					},

					{
						"title": "消耗量",
						"key": "cost",
						"align": 'center',
						sortable: 'custom'
					},
					{
						"title": "转化个数",
						"key": "account_convert",
						"align": 'center',
						sortable: 'custom'
					},
					{
						"title": "平均成本",
						"key": "avg_cost",
						"align": 'center',
						sortable: 'custom'
					},
					{
						"title": "点击数",
						"key": "account_click",
						"align": 'center',
						sortable: 'custom'
					},
					{
						"title": "单次点击成本",
						"key": "account_click_cost",
						"align": 'center',
						sortable: 'custom'
					},
					{
						"title": "投放出价",
						"key": "ad_platform_cdp_promotion_bid",
						"align": 'center',
						sortable: 'custom'
					},
					{
						"title": "投放备注",
						"slot": "remark",
						"align": 'center',
					},
				],
			}
		},
		computed: {
			...mapGetters(['token', 'userInfo'])
		},
		mounted: function() {
			this.loadData();

		},
		methods: {

			async loadData() {
				let that = this;
				let data = {}
				data.token = this.token;
				let res = await getAdvCity(that, data);
				that.cityList = res.data.list;
				res = await getCidTypeList(that, data);
				that.cidTypeList = res.data.list;
				res = await getToutiaoSrc(that, data);
				that.srcList = res.data.list;
				res = await getAllAccountList(that, data);
				that.accountList = res.data.list;
				res = await getAllOperationList(that, data);
				that.operationList = res.data.list;
				console.log(that.userInfo.role_type)
				if (that.userInfo.role_type == 15) {
					that.operationList = [];
					that.accountList = [];
					that.srcList = [];
				}
				this.getList();
			},
			mySearch(e) {
				this.page = 1;
				this.getList();
			},
			initSearch() {
				this.page = 1;
				this.pageSize = 20;
				this.city = '';
				this.src = '';
				this.cid_type = '';
				this.searchAdid = '';
				this.timePeriod = '1';
				this.timePeriodDate = [];
				this.operationUser = [];
				this.account = [];
				this.getList();
			},
			async getList() {
				let that = this;
				let data = {}
				data.page = that.page
				data.pageSize = that.pageSize
				data.token = that.token;
				data.city = that.city
				data.src = that.src
				data.cid_type = that.cid_type
				data.searchAdid = that.searchAdid
				data.operationUser = that.operationUser
				data.account = that.account
				data.timePeriod = that.timePeriod
				data.timePeriodDate = that.timePeriodDate
				data.sort = that.sort
				data.zero_convert = that.zero_convert
				let res = await getAdidDataList(that, data);
				that.datas = res.data.list;
				console.log(res)
				that.count = res.count;
			},
			lookClientlist() {
				let that = this;
				that.clientListModal = true;
			},
			adidDataClick(adid) {
				let that = this;
				if (adid == "合计") {
					that.adid = "";
				} else {
					that.adid = adid;
				}
				that.adidDataModal = true;
			},
			handleSortChange({
				column,
				prop,
				order
			}) {
				this.sort.field = column.key ? column.key : column.slot;
				this.sort.order = order;
				this.page = 1;
				this.getList();
			},
			changeDate(e) {
				//this.getList();
			},
			changeTimePeriod(e) {
				this.timePeriodDate = e;
				console.log(this.timePeriodDate)
				this.getList();
			},
			changePage(e) {
				this.page = e;
				this.getList();
			},
			changeSize(e) {
				this.pageSize = e;
				this.getList();
			},
		},
	}
</script>
<style scoped lang="less">
	.red {
		color: red;
	}

	.multiple {
		display: flex;
		justify-content: left;
		margin-top: 10px;
		align-items: center;

		.child-div {
			width: 70px;
			height: 20px;
			margin-right: 30px;
			text-align-last: justify;
		}
	}

	.hong {
		color: #F56171;
		font-weight: bold;
	}

	.lan {
		color: #124386;
		font-weight: bold;
	}

	.sousuo {
		width: 100%;
		display: flex;
		justify-content: space-between;
	}

	.yl-flex {
		display: flex;
	}

	.flex_between {
		align-items: flex-start;
		display: flex;
		justify-content: space-between;
		margin-bottom: 10px;
	}

	.ivu-table-header thead tr th {
		text-align: center !important;
	}

	.ivu-table-cell {
		padding-left: 2px;
		padding-right: 2px;
		text-align: center;
	}

	.ivu-table table {
		width: 100% !important;
	}

	.green-bg {
		background: #18bc9c;
	}

	.blue-bg {
		background: #54A1F3;
	}

	.person {
		font-size: 14px;
		color: white;
		border-radius: 50%;
		width: 22px;
		height: 20px;
	}

	.in-block {
		display: inline-block;
	}

	.one {

		background-color: #E74C3C;
		cursor: pointer;
		color: #fff;

	}
	.twoplus {

		background-color: #F1C40F;
		cursor: pointer;
		color: #fff;

	}
	.threeplus {
	
		background-color: #2ECC71;
		cursor: pointer;
		color: #fff;
	
	}
	.cost {
	
		background-color: #E67E22;
		cursor: pointer;
		color: #fff;
	
	}
	.is
	.is_stop_city {
		background-color: #9c4e00;
		cursor: pointer;
		color: #fff;
	}
</style>